<template>
  <div>
    <div class="text-xs w-full">
      <HeroTableFilter
        @getPageSize="HandlerData"
        @getSearch="HandlerSearch"
        @selectedFilter="HandlerFilter"
        :itemApprovalCount="approvalTypeCountList"
      />
      <table class="w-full border-collapse">
        <thead>
          <tr class="bg-gray-100 font-bold">
            <th class="border-y border-gray-300 px-2 py-2 text-left">
              Member Name
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Payee Name
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Payment Channel
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Account Number
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-right">
              Guaranteed Amount
            </th>

            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Status
            </th>
            <th class="border-y border-gray-300 px-2 py-2 text-center">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in updatedDataArray"
            :key="item.id"
            class="odd:bg-white even:bg-gray-50 hover:bg-gray-100 transition"
          >
            <td class="border-y border-gray-300 px-2 py-2">
              <div class="flex items-center gap-4">
                <div class="flex flex-col">
                  <span class="font-semibold">{{ item.membername }}</span>
                  <span class="text-gray-600">{{
                    item.transactionnumber
                  }}</span>
                </div>
              </div>
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-center">
              {{ item.paymentpayee }}
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-center">
              {{ item.paymentprovider }}
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-center">
              {{ item.paymentaccount }}
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-right">
              {{ amountFormat(item.reimbursableamount) }}
            </td>

            <td class="border-y border-gray-300 px-2 py-2 text-center">
              <span
                class="inline-block px-3 py-1 rounded-full text-xs font-medium"
                :class="{
                  'bg-green-100 text-green-800':
                    item.paymentstatus === 'Completed',
                  'bg-yellow-100 text-yellow-800':
                    item.paymentstatus === 'Pending',
                }"
              >
                {{ item.paymentstatus }}
              </span>
            </td>
            <td class="border-y border-gray-300 px-2 py-2 text-center">
              <div class="flex gap-2 justify-center">
                <icon-download
                  @click="
                    exportPDF(item, amountFormatPH(item.reimbursableamount))
                  "
                  class="text-blue-600 hover:underline text-xs"
                >
                  View
                </icon-download>
                <icon-edit
                  v-if="item.paymentstatus !== 'Completed'"
                  @click="editHandler(item)"
                  class="text-yellow-600 hover:underline text-xs cursor-pointer"
                >
                  Edit
                </icon-edit>
                <icon-edit
                  v-else
                  class="text-gray-400 text-xs cursor-not-allowed"
                >
                  Edit
                </icon-edit>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <PaginationGrid
        :totalPages="totalPages"
        :currentPage="currentPage"
        @update:currentPage="handlePageChange"
      />
    </div>
  </div>

  <DataDetails
    :itemDataDetails="renderDataDetails"
    :isModalTriggired="isTriggiered"
    @close="isTriggiered = false"
  />
</template>

<script>
import HeroTableFilter from "@/components/common/HeroTableFilter.vue";
import PaginationGrid from "@/components/common/HeroPagination.vue";
import DataDetails from "@/components/partial/Application/SectionDetailView.vue";
import IconEdit from "@/components/svg/EditSVG.vue";
import IconDownload from "@/components/svg/DownloadSVG.vue";
import { ref, onMounted, toRefs, inject, watch, computed } from "vue";
import UsedPaginationUtils from "@/utils/reusables/pagination";
import pdfGenerateHandler from "@/utils/reusables/pdfLetter";

export default {
  components: {
    HeroTableFilter,
    PaginationGrid,
    DataDetails,
    IconEdit,
    IconDownload,
  },
  props: {
    actionButton: Boolean,
    isReload: Boolean,
  },
  emits: ["actionHandler"],
  setup(props, { emit }) {
    const { paginationItem, totalPages, filterLimit } = UsedPaginationUtils();
    const { exportPDF } = pdfGenerateHandler();
    const axios = inject("$axios");
    const selectedPageSize = ref(0);
    const searchData = ref();
    const updatedDataArray = ref([]);
    const renderDataDetails = ref([]);
    const renderDataUpdate = ref([]);
    const isTriggiered = ref(false);
    const isModalUpdate = ref(false);
    const selectedFilterStatus = ref("All");
    const approvalTypeCountList = ref({});

    onMounted(() => {
      fetchData();
    });

    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `/portal/application/reimbursement/payment`,
          {
            params: {
              search: searchData.value,
              pageSize: paginationItem.PageSize,
              page: paginationItem.currentPage - 1,
            },
          }
        );
        updatedDataArray.value = data;
        fetchDataCount();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchDataCount = async () => {
      try {
        const { data } = await axios.get(
          `portal/application/reimbursement/count`,
          {
            params: {
              search: searchData.value,
            },
          }
        );
        paginationItem.totalItems = data.total;
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    const HandlerData = (val) => {
      selectedPageSize.value = val;
      paginationItem.PageSize = val;
    };
    const HandlerSearch = (val) => {
      searchData.value = val;
    };

    watch(() => selectedPageSize.value, fetchData);
    watch(() => searchData.value, fetchData);
    watch(() => selectedFilterStatus.value, fetchData);
    watch(
      () => props.isReload,
      (newVal) => {
        if (newVal) {
          fetchData();
          emit("done-reload");
        }
      }
    );
    const handlePageChange = (page) => {
      paginationItem.currentPage = page;
      fetchData();
    };
    const viewHandler = (item) => {
      renderDataDetails.value = item;
      isTriggiered.value = true;
    };
    const editHandler = (item) => {
      // renderDataUpdate.value = item;
      emit("renderUpdate", true, item);
    };
    const HandlerFilter = (val) => {
      selectedFilterStatus.value = val;
    };
    const amountFormat = (val) => {
      return `₱ ${val.toLocaleString("en-PH", {
        minimumFractionDigits: 2,
      })}`;
    };
    const amountFormatPH = (val) => {
      return `PHP ${val.toLocaleString("en-PH", {
        minimumFractionDigits: 2,
      })}`;
    };

    return {
      fetchData,
      updatedDataArray,
      ...toRefs(paginationItem),
      totalPages,
      filterLimit,
      HandlerData,
      HandlerSearch,
      selectedPageSize,
      searchData,
      fetchDataCount,
      handlePageChange,
      viewHandler,
      renderDataDetails,
      renderDataUpdate,
      isTriggiered,
      editHandler,
      isModalUpdate,
      HandlerFilter,
      selectedFilterStatus,
      approvalTypeCountList,
      amountFormat,
      amountFormatPH,
      exportPDF,
    };
  },
};
</script>
